import React, { useEffect, useState } from 'react'
import camelCase from 'lodash/camelCase'

import Button from '@react/react-spectrum/Button'
import Dialog from '@react/react-spectrum/Dialog'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import { Table, TBody, TD, TH, THead, TR } from '@react/react-spectrum/Table'
import Textfield from '@react/react-spectrum/Textfield'

import Delete from '@react/react-spectrum/Icon/Delete'
import Edit from '@react/react-spectrum/Icon/Edit'

import './CssProperties.scss'

export const CssProperties = ({ fields, disabled, onChange }) => {
  const [rows, setRows] = useState([])
  const hasEmptyRow = rows.length > 0 && rows.filter((r) => !r.prop).length > 0
  const saveField = (index, propName) => (value) => {
    const _value = propName === 'prop' ? value.trim() : value
    const newRows = rows.map((r, idx) => (idx === index ? { ...r, [propName]: _value } : r))
    setRows(newRows)
    onChange(newRows)
  }

  const addRow = () => {
    if (!hasEmptyRow) {
      const newRows = [...rows, {}]
      setRows(newRows)
    }
  }

  const deleteRow = (index) => {
    const newRows = rows.filter((r, idx) => idx !== index)
    setRows(newRows)
    onChange(newRows)
  }

  useEffect(() => {
    setRows(fields)
  }, [fields])
  return (
    <div className='CssProperties'>
      <Table onSubmit={(evt) => evt.preventDefault()}>
        <THead>
          <TH>Property</TH>
          <TH>Value</TH>
          <TH></TH>
        </THead>
        <TBody>
          {rows.map((field, idx) => (
            <TR key={'field-' + idx}>
              <TD>
                <Textfield value={field.prop || ''} onChange={saveField(idx, 'prop')} disabled={disabled} />
              </TD>
              <TD>
                <Textfield value={field.value || ''} onChange={saveField(idx, 'value')} disabled={disabled} />
              </TD>
              <TD>
                <Button
                  variant='tool'
                  aria-label='Delete'
                  icon={<Delete />}
                  onClick={() => deleteRow(idx)}
                  disabled={disabled}
                />
              </TD>
            </TR>
          ))}
          <TR onClick={addRow}>
            <TD>
              <Button variant='action' quiet label='+ Add' disabled={disabled || hasEmptyRow} />
            </TD>
            <TD />
            <TD />
          </TR>
        </TBody>
      </Table>
    </div>
  )
}

export const CssPropertiesDialog = ({ label, fields, disabled, onChange, ...otherProps }) => {
  const [newContent, setNewContent] = useState((Array.isArray(fields) && fields) || [])

  const onConfirm = () => {
    const filteredContent = newContent
      ? newContent
          .filter(Boolean)
          .map(({ prop, value }) => prop && { prop: camelCase(prop).trim(), value })
          .filter(Boolean)
      : []
    onChange(filteredContent)
  }
  return (
    <Dialog
      {...otherProps}
      className={'option-editor--dialog'}
      title={label || 'Option Editor'}
      confirmLabel='Save'
      cancelLabel='Discard'
      onConfirm={onConfirm}
      role='dialog'
    >
      <CssProperties fields={newContent} onChange={setNewContent} disabled={disabled} />
    </Dialog>
  )
}

export const CssPropertiesInput = ({ label, fields, disabled, onChange }) => (
  <ModalTrigger>
    <Button icon={<Edit />} disabled={disabled}>
      Open Editor
    </Button>
    <CssPropertiesDialog label={label} fields={fields} onChange={onChange} disabled={disabled} />
  </ModalTrigger>
)
